import { useCallback, useEffect, useState } from "react"
import { Link } from "react-router-dom"

import SecondNavbar from "../components/SecondNavbar"
import { getApiHelper } from "../util/apiHelpers.js"

const ENDPOINT = "fortellis-historical-ingestion"

const errorMessage = (result, fallback) =>
  result?.response?.data?.message || result?.message || fallback

export default function FortellisHistoryPending() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState("")

  const load = useCallback(async () => {
    setLoading(true)
    setError("")
    const approver = await getApiHelper(`${ENDPOINT}/approver`)
    if (approver?.status === 200 && !approver.data?.isApprover) {
      setError(
        "Only the configured Fortellis approver may view pending requests."
      )
      setLoading(false)
      return
    }
    const result = await getApiHelper(`${ENDPOINT}/pending`)
    if (result?.status === 200) {
      setItems(Array.isArray(result.data) ? result.data : [])
    } else {
      setError(errorMessage(result, "Pending requests could not be loaded."))
    }
    setLoading(false)
  }, [])

  useEffect(() => {
    load()
  }, [load])

  return (
    <div className="min-h-screen flex flex-col bg-[#002E5D] px-[40px] pb-[40px] 2xl:text-[14px] text-[12px]">
      <div className="grid w-full h-[145px] text-[#FFFFFF]">
        <SecondNavbar />
      </div>
      <div className="flex justify-center">
        <div className="bg-white rounded-xl w-[720px] max-w-full p-8 shadow-xl">
          <h1 className="font-bold text-[#174a7e] text-[22px] mb-1">
            Pending historical ingestion requests
          </h1>
          <p className="text-[13px] text-[#667085] mb-6">
            Open a request to approve or reject it. Sign-in is required.
          </p>

          {loading && <p className="text-[14px] text-[#475467]">Loading…</p>}

          {!loading && error && (
            <p className="text-[13px] text-red-500 font-medium">{error}</p>
          )}

          {!loading && !error && items.length === 0 && (
            <p className="text-[14px] text-[#475467]">
              There are no requests waiting for approval.
            </p>
          )}

          {!loading && !error && items.length > 0 && (
            <ul className="divide-y divide-[#F2F4F7]">
              {items.map((item) => (
                <li
                  key={item.id}
                  className="py-4 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between"
                >
                  <div>
                    <p className="text-[14px] font-semibold text-[#1d2939]">
                      {item.dealerName || `Dealer ${item.dealerId}`}
                    </p>
                    <p className="text-[12px] text-[#667085]">
                      Requested by {item.requesterEmail} · ~$
                      {Number(item.estimatedCostUsd).toFixed(0)} USD ·{" "}
                      {item.lookbackYears}y {item.dataScope}
                    </p>
                  </div>
                  <Link
                    to={`/fortellis-history/approve?requestId=${encodeURIComponent(
                      item.id
                    )}`}
                    className="mt-2 sm:mt-0 shrink-0 inline-flex rounded-lg px-4 py-2 text-[13px] font-semibold text-white bg-[#298FC2] hover:bg-[#1f7aa8] transition-colors"
                  >
                    Review
                  </Link>
                </li>
              ))}
            </ul>
          )}

          <div className="border-t border-[#F2F4F7] mt-6 pt-4">
            <Link
              to="/"
              className="text-[13px] font-semibold text-[#298FC2] hover:underline"
            >
              Go to VINAmp
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
